import { ComponentProps } from 'react';

import { TConditionalWrapperProps } from './types/public';

export function ConditionalWrapper<A, B>(
	props: TConditionalWrapperProps<A, B>
) {
	const {
		if: _if,
		ThenComponent,
		thenRender,
		ElseComponent,
		elseRender,
		children,
		...wrappersProps
	} = props;
	const condition = typeof _if === 'function' ? _if() : _if;

	if (condition) {
		if (ThenComponent) {
			return (
				<ThenComponent
					{...(wrappersProps as ComponentProps<typeof ThenComponent>)}
				>
					{children}
				</ThenComponent>
			);
		} else {
			return thenRender(children);
		}
	} else {
		if (ElseComponent) {
			return (
				<ElseComponent
					{...(wrappersProps as ComponentProps<typeof ElseComponent>)}
				>
					{children}
				</ElseComponent>
			);
		} else if (elseRender) {
			return elseRender(children);
		}

		// eslint-disable-next-line react/jsx-no-useless-fragment -- yields JSX.Element for ReactNode children
		return <>{children}</>;
	}
}
